const ThirdPartyComponentsNavigation = {
  id: '3rd-party-components',
  title: '3rd Party Components',
  type: 'collapse',
  icon: 'settings_input_component',
  children: [
    {
      id: 'react-hook-form',
      title: 'React Hook Form',
      type: 'item',
      url: '/documentation/third-party-components/react-hook-form',
    },
    {
      id: 'react-table',
      title: 'React Table',
      type: 'item',
      url: '/documentation/third-party-components/react-table',
    },
    {
      id: 'google-map-react',
      title: 'Google Map React',
      type: 'item',
      url: '/documentation/third-party-components/google-map-react',
    },
    {
      id: 'react-apexcharts',
      title: 'React Apex Charts',
      type: 'item',
      url: '/documentation/third-party-components/react-apexcharts',
    },
  ],
};

export default ThirdPartyComponentsNavigation;
